export const GET_PRODUCTS_REQUEST = "GET_PRODUCTS_REQUEST";
export const GET_PRODUCTS_SUCCESS = "GET_PRODUCTS_SUCCESS";
export const GET_PRODUCTS_FAILURE = "GET_PRODUCTS_FAILURE";
export const SELECTED_PRODUCT = "SELECTED_PRODUCT";
export const REMOVE_SELECTED_PRODUCT = "REMOVE_SELECTED_PRODUCT";
export const SORT_PRODUCTS_BY_PRICE = "SORT_PRODUCTS_PRICE_BY_PRICE";

export const DELETE_PRODUCTS_SUCCESS = "DELETE_PRODUCTS_SUCCESS"
export const DELETE_PRODUCTS_FAILURE = "DELETE_PRODUCTS_FAILURE"
export const DELETE_PRODUCTS_REQUEST = "DELETE_PRODUCTS_REQUEST"

export const UPDATE_PRODUCTS_SUCCESS = "UPDATE_PRODUCTS_SUCCESS"
export const UPDATE_PRODUCTS_FAILURE = "UPDATE_PRODUCTS_FAILURE"
export const UPDATE_PRODUCTS_REQUEST = "UPDATE_PRODUCTS_REQUEST"
